import {Storage} from "@/services/Storage";
import axios from "axios";
import store from "@/store";

export default {
    name: 'accounts',
    state: {
        debtors : [],
        debtorCurrency : null,
        currentDebtorPriceType : {
            DiscountType : `Normal`,
            DiscountAmount : 0,
        },
    },
    getters: {
        getDebtors: (state) =>state.debtors,
        getDebtorCurrency: (state) => {
            let cur = state.debtorCurrency
            if (!cur) cur = store.getters.getBaseCurrency
            return cur;
        },
        getCurrentDebtorPriceType: (state) =>state.currentDebtorPriceType,
        getDebtorByID : (state) => (id) => {
            let customer = state.debtors.find(debtor => debtor.Id === id)
            if (customer){
                return customer.Name;
            }
            return id;
        },
        getCurrentDebtorDetails : (state) => {
            let customerID = state.customer;
            if (!customerID) return null;
            return state.debtors.find(debtor => debtor.Id === customerID);
        },
        getDebtorPrice: (state) => (payload) => {
            let item = payload.item;
            let debtorPriceType = state.currentDebtorPriceType;

            let type = debtorPriceType.DiscountType;
            let discountDecimal = Number(debtorPriceType.DiscountAmount) / 100;

            switch (type) {
                case "At Cost":
                    return item.InclCost;
                case "Price 1":
                    return item.price1;
                case "Price 2":
                    return item.price2;
                case "Price 3":
                    return item.price3;
                case "Price 4":
                    return item.price4;
                case "Price 5":
                    return item.price5;
                case "From Cost":
                    return item.InclCost * discountDecimal;
                case "From Selling":
                    return item.SellingIncl * discountDecimal;
                default:
                    return item.SellingIncl
            }
        },
    },
    mutations: {
        setDebtors : (state , data) => state.debtors = data,
        setCurrentDebtorPriceType : (state , data) => state.currentDebtorPriceType = data,
        setDebtorCurrency : (state , data) => state.debtorCurrency = data,
    },
    actions: {
        getAllDebtors : async (context,payload) => {
            let store = await Storage.getDefaultStore();
            payload = {
                ...payload,
                blocked: false
            }
            return axios.post(franchiseTomcatApi + `debtor/${store.StoreDB}/search`,payload)
                .then(({data})=> context.commit('setDebtors', data))
                .catch((err) => errorHandler.tomcatError(err))
        },
        createDebtor : async (context , payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(serverApi + `debtor/${store.StoreDB}`,payload)
                .then(({data})=> data)
                .catch((err) => errorHandler.tomcatError(err))
        },

    }
}
